"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.AppSwitcherComponent = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _AppSwitcherContent = _interopRequireDefault(require("./components/AppSwitcherContent"));

var _apps = _interopRequireDefault(require("../../../../config/apps"));

var _ActivationModal = require("../Activation/ActivationModal");

var _ = require("../../../../");

var _Layout = require("./components/IntegratedExperience/Layout");

var _FeedbackModal = _interopRequireDefault(require("./components/IntegratedExperience/FeedbackModal"));

var _productsStatus = require("./productsStatus");

var _NavDropdown = require("../NavDropdown");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var AppSwitcherComponent = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(AppSwitcherComponent, _React$Component);

  var _super = _createSuper(AppSwitcherComponent);

  function AppSwitcherComponent() {
    var _this;

    (0, _classCallCheck2["default"])(this, AppSwitcherComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onLinkClick", function (product, productStatus) {
      var _this$props = _this.props,
          onClose = _this$props.onClose,
          onSelectProduct = _this$props.onSelectProduct,
          features = _this$props.features;
      var isCrossActivationEnabled = features && features.crossActivation;

      if (typeof onSelectProduct === 'function' && isCrossActivationEnabled) {
        onSelectProduct(product, productStatus);
      }

      if (typeof onClose === 'function') {
        onClose();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onShowFeedbackModal", function (onFeedbackComplete) {
      var _this$props2 = _this.props,
          onClose = _this$props2.onClose,
          onShowFeedbackModal = _this$props2.onShowFeedbackModal,
          features = _this$props2.features;
      var isIntegratedExperience = features && features.integratedExperience;

      if (typeof onShowFeedbackModal === 'function' && isIntegratedExperience) {
        onShowFeedbackModal(onFeedbackComplete);
      }

      if (typeof onClose === 'function') {
        onClose();
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(AppSwitcherComponent, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          currentProduct = _this$props3.currentProduct,
          _this$props3$environm = _this$props3.environment,
          environment = _this$props3$environm === void 0 ? 'production' : _this$props3$environm,
          features = _this$props3.features,
          inverted = _this$props3.inverted,
          swicusOrgId = _this$props3.swicusOrgId,
          onReloadHandler = _this$props3.onReloadHandler,
          onShowFeedbackModal = _this$props3.onShowFeedbackModal,
          rest = (0, _objectWithoutProperties2["default"])(_this$props3, ["currentProduct", "environment", "features", "inverted", "swicusOrgId", "onReloadHandler", "onShowFeedbackModal"]);
      var isIntegratedExperience = features && features.integratedExperience;
      return /*#__PURE__*/_react["default"].createElement(_NavDropdown.NavDropdown, (0, _extends2["default"])({
        className: "cloud-ui-app-switcher",
        inverted: inverted,
        label: /*#__PURE__*/_react["default"].createElement("div", {
          className: "nav-icon-wrapper",
          "data-qa": "app-switcher"
        }, /*#__PURE__*/_react["default"].createElement(_.Icon, {
          name: "app-switcher"
        })),
        pinned: true,
        position: "bottom right",
        tooltip: "SolarWinds Application Management Suite"
      }, rest), isIntegratedExperience ? /*#__PURE__*/_react["default"].createElement(_Layout.Layout, {
        currentProduct: currentProduct,
        environment: environment,
        features: features,
        inverted: inverted,
        onLinkClick: this.onLinkClick,
        onReloadHandler: onReloadHandler,
        swicusOrgId: swicusOrgId,
        onShowFeedbackModal: this.onShowFeedbackModal
      }) : /*#__PURE__*/_react["default"].createElement(_AppSwitcherContent["default"], {
        currentProduct: currentProduct,
        environment: environment,
        features: features,
        products: _apps["default"],
        onLinkClick: this.onLinkClick,
        swicusOrgId: swicusOrgId,
        inverted: inverted
      }));
    }
  }]);
  return AppSwitcherComponent;
}(_react["default"].Component);

exports.AppSwitcherComponent = AppSwitcherComponent;
var AppSwitcherWithEvents = (0, _NavDropdown.withNavDropdownEvents)(AppSwitcherComponent);

var AppSwitcher = /*#__PURE__*/function (_React$Component2) {
  (0, _inherits2["default"])(AppSwitcher, _React$Component2);

  var _super2 = _createSuper(AppSwitcher);

  function AppSwitcher() {
    var _this2;

    (0, _classCallCheck2["default"])(this, AppSwitcher);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "state", {
      isModalOpen: false,
      isFeedbackModalOpen: false,
      product: '',
      productStatus: ''
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "openModalForProduct", function (product, productStatus) {
      var statusesForModal = [_productsStatus.PRODUCT_STATUS.ACCESS_NEEDED, _productsStatus.PRODUCT_STATUS.CAN_ACTIVATE];

      if (product && statusesForModal.includes(productStatus)) {
        _this2.setState({
          isModalOpen: true,
          product: product,
          productStatus: productStatus
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "closeModal", function () {
      _this2.setState({
        isModalOpen: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "openFeedbackModal", function (onFeedbackComplete) {
      _this2.setState({
        onFeedbackComplete: onFeedbackComplete
      });

      _this2.setState({
        isFeedbackModalOpen: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "closeFeedbackModal", function () {
      _this2.setState({
        isFeedbackModalOpen: false
      });
    });
    return _this2;
  }

  (0, _createClass2["default"])(AppSwitcher, [{
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props4 = this.props,
          swicusOrgId = _this$props4.swicusOrgId,
          _this$props4$environm = _this$props4.environment,
          environment = _this$props4$environm === void 0 ? 'production' : _this$props4$environm,
          currentProduct = _this$props4.currentProduct;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(AppSwitcherWithEvents, (0, _extends2["default"])({}, this.props, {
        onSelectProduct: function onSelectProduct(product, productStatus, features) {
          return _this3.openModalForProduct(product, productStatus, features);
        },
        onShowFeedbackModal: this.openFeedbackModal
      })), /*#__PURE__*/_react["default"].createElement(_ActivationModal.ActivationModal, {
        swicusOrgId: swicusOrgId,
        environment: environment,
        isOpen: this.state.isModalOpen,
        onClose: this.closeModal,
        targetProduct: this.state.product,
        originProduct: currentProduct,
        productStatus: this.state.productStatus
      }), /*#__PURE__*/_react["default"].createElement(_FeedbackModal["default"], {
        swicusOrgId: swicusOrgId,
        environment: environment,
        isOpen: this.state.isFeedbackModalOpen,
        onFeedbackComplete: this.state.onFeedbackComplete,
        onClose: this.closeFeedbackModal,
        source: "combinednav"
      }));
    }
  }]);
  return AppSwitcher;
}(_react["default"].Component);

var _default = AppSwitcher;
exports["default"] = _default;